module.exports = __webpack_public_path__ + "static/plains-26b10e3548b95190c8053e91736d97ec.png";